<template>
  <modalWindow v-if="logging" @close="logging=false" width="800">
    <div class="titlebar">Logs {{ name ? `(${name})` : '' }}</div>
    <table>
      <thead>
        <tr>
          <th>Datum</th>
          <th>IP-adres</th>
          <th>Type</th>
        </tr>
      </thead>
      <tr
        v-for="log in logs"
        :key="log.id"
      >
        <td>
          {{(new Date(log.date)).toLocaleDateString()}}
          ({{(new Date(log.date)).toLocaleTimeString()}})
        </td>
        <td>{{log.ip}}</td>
        <td>{{log.type}}</td>
      </tr>
      <tr>
        <td colspan="3">
          <button
            class="show-all-logs"
            @click="showUserActivities(user)"
          >
            Alle activiteiten tonen
          </button>
        </td>
      </tr>
    </table>
  </modalWindow>
</template>

<script>
export default {
  name: 'UserLogs',
  data() {
    return {
      logging: false,
      logs: [],
      logsPage: 0,
      logsResultsPerPage: 20,
      name: '',
      user: null,
    };
  },
  methods: {
    showUserActivities(userId) {
      this.$store.state.activityUserId = userId;
      this.$store.state.currentView = 'Activity';
    },
    userLogs(user, name) {
      this.name = name;
      this.user = user;
      this.logs = [];
      this.logsPage = 0;
      this.logging = true;
      this.sdk.getUserLogs(user, (response) => {
        this.logs = response.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  tr:last-child {
    &:hover {
      background: none;
    }

    td {
      text-align: center;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }
</style>
